<template>
  <div id="KPCool">
    <vs-card id="HeaderPage" class="ml-3" style="text-align: center">
      <h5>Temperature Sensor</h5>
    </vs-card>
    <vs-row vs-w="12">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-lg="4"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card class="cardBorder">
          <img
            src="../../../../assets/images/KPCool/_Neon Green and Purple Friendly Professional Messenger App Roadmap Presentation (1900 x 1080 px).gif"
            class="container-fluid mt-4"
            width="500"
            height="280"
          />
        </vs-card>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-lg="3"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card class="cardBorder">
          <br />
          <h3 style="text-align: center">Temperature</h3>
          <vs-row class="mt-3">
            <img
              src="../../../../assets/images/KPCool/8.png"
              class="container-fluid"
              style="width: 40%"
            />
            <vs-spacer></vs-spacer>
            <h1 style="font-family: '7 Segment'; font-size: 550%" class="mt-2">
              {{ TempList[0].temp.toFixed(0) }}°C
            </h1>
          </vs-row>
          <br />
          <h3 style="text-align: center">Humidity</h3>
          <vs-row class="mt-3">
            <img
              src="../../../../assets/images/KPCool/7.png"
              class="container-fluid"
              style="width: 40%"
            />
            <vs-spacer></vs-spacer>
            <h1 style="font-family: '7 Segment'; font-size: 550%" class="mt-2">
              {{ TempList[0].humid.toFixed(0) }}%
            </h1>
          </vs-row>
        </vs-card>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-lg="5"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-row>
          <vs-card class="cardBorder">
            <h3 style="text-align: center" class="mb-4">Temperature</h3>
            <vs-row
              class="ml-2"
              style="justify-content: center; align-items: center"
            >
              <div class="ml-4">
                <vs-col>
                  <vs-chip color="#808080" style="width: 70%" class="ml-2">
                    Avg
                  </vs-chip>
                  <h3>{{ avgValTemp.toFixed(2) }}°C</h3>
                </vs-col>
              </div>
              <vs-spacer />
              <div>
                <vs-col>
                  <vs-chip color="success" style="width: 70%" class="ml-2">
                    Min
                  </vs-chip>
                  <h3>{{ minValTemp.toFixed(2) }}°C</h3>
                </vs-col>
              </div>
              <vs-spacer />
              <div class="mr-4">
                <vs-col>
                  <vs-chip color="danger" style="width: 70%" class="ml-2">
                    Max
                  </vs-chip>
                  <h3>{{ maxValTemp.toFixed(2) }}°C</h3>
                </vs-col>
              </div>
            </vs-row>
          </vs-card>

          <vs-card class="cardBorder">
            <h3 style="text-align: center" class="mb-4">Humidity</h3>
            <vs-row
              class="ml-2"
              style="justify-content: center; align-items: center"
            >
              <div class="ml-4">
                <vs-col>
                  <vs-chip color="#808080" style="width: 70%" class="ml-2">
                    Avg
                  </vs-chip>
                  <h3>{{ avgValHumid.toFixed(2) }}%</h3>
                </vs-col>
              </div>
              <vs-spacer />
              <div>
                <vs-col>
                  <vs-chip color="success" style="width: 70%" class="ml-2">
                    Min
                  </vs-chip>
                  <h3>{{ minValHumid.toFixed(2) }}%</h3>
                </vs-col>
              </div>
              <vs-spacer />
              <div class="mr-4">
                <vs-col>
                  <vs-chip color="danger" style="width: 70%" class="ml-2">
                    Max
                  </vs-chip>
                  <h3>{{ maxValHumid.toFixed(2) }}%</h3>
                </vs-col>
              </div>
            </vs-row>
          </vs-card>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row vs-w="12">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card class="cardBorder">
          <vs-row class="mb-3">
            <div>
              <h4 class="mt-2 ml-2">{{ TempList[0].name }}</h4>
            </div>
            <vs-spacer />
            <vs-icon
              icon="settings"
              v-b-modal.modal-1
              size="25px"
              color="success"
            ></vs-icon>
          </vs-row>
          <vs-row>
            <vs-spacer />
            <div class="mr-4">
              <p style="color: #fc8200" class="mb-1">avg</p>
              <p>{{ avgtemp.toFixed(0) }}</p>
            </div>
            <div class="mr-4">
              <p style="color: #ff006a" class="mb-1">min</p>
              <p>{{ mintemp.toFixed(0) }}°C</p>
            </div>
            <div class="mr-4">
              <p style="color: #d400ff" class="mb-1">max</p>
              <p>{{ maxtemp.toFixed(0) }}°C</p>
            </div>
          </vs-row>
          <div :key="chartKey">
            <graph
              :width="400"
              :height="300"
              :chartdata="this.datachart1"
              :chartdata2="this.datachart2"
              :options="this.labelInput"
            />
          </div>
        </vs-card>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-card class="cardBorder"
          ><vs-row class="mt-2 mb-2"><h3>Temperature Sensor List</h3></vs-row>
          <Table :items="TempList" />
        </vs-card>
      </vs-col>
    </vs-row>
    <b-modal id="modal-1" hide-header-close centered size="lg">
      <template #modal-title>
        <h4 class="textSuccess">Select Date</h4>
      </template>
      <vs-row>
        <vs-col class="mt-2" vs-lg="4" vs-xs="12">
          <a class="ml-1">Select Start Date</a>

          <datetime
            class="mt-2"
            v-model="mintime"
            type="datetime"
            input-class="form-control"
            placeholder="YYYY/MM/DD H:i:s"
          ></datetime>
        </vs-col>
        <vs-col class="mt-2" vs-lg="4" vs-xs="12">
          <a class="ml-1">Select End Date</a>

          <datetime
            class="mt-2"
            v-model="maxtime"
            type="datetime"
            input-class="form-control"
            placeholder="YYYY/MM/DD H:i:s"
          ></datetime>
        </vs-col>
      </vs-row>
      <br />
      <p v-if="alertselect === true" style="color: red" class="ml-3">
        There is no information during this time.
      </p>
      <template #modal-footer="{}">
        <vs-button
          color="primary"
          class="mr-2 btnBorderpop"
          @click="selectTimelengthChart(mintime, maxtime)"
          type="filled"
          >Submit</vs-button
        >
        <vs-button
          class="btnBorderpop"
          color="dark"
          @click="closeModal"
          type="flat"
          >Cancel</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import Graph from "./graph.vue";
import Table from "@/views/components/dashboard/KPCool/table.vue";
import moment from "moment";
export default {
  data() {
    return {
      select2: ["1 Day", "1 Week", "1 Month", " 1 Year"],
      datachart1: [],
      datachart2: [],
      labelInput: [],
      chartKey: 0,
      timelength: "1 Day",
      sensor: "Fridge Temp 01",
      TempList: [],
      newArray1: "",
      newArray3: [],
      newArray4: [],
      newArray2: "",
      dateTime: "",
      dateTime2: [],
      maxValTemp: "",
      minValTemp: "",
      maxValHumid: "",
      minValHumid: "",
      sumValTemp: "",
      avgValTemp: "",
      avgValHumid: "",
      mintime: "",
      maxtime: "",
      mintemp: 0,
      maxtemp: 0,
      avgtemp: 0,
      alertselect: false,
    };
  },
  created() {
    this.fetchData();
    this.getChartData();
    this.defaultChart();
  },
  methods: {
    fetchData() {
      this.$API.get("indoorsensor").then((result) => {
        this.ssf = result.data.length;
        for (var i = 0; i < this.ssf; i++) {
          let obj = result.data[i];
          if (
            moment(obj.lastdate).format("Do hA") == moment().format("Do hA") &&
            obj.subtype == "S1"
          ) {
            let payload = {
              name: obj.name,
              mac: obj.mac,
              type: obj.subtype,
              timest: obj.timestamp,
              temp: obj.sensordata.temperature,
              humid: obj.sensordata.humidity,
              bat: obj.sensordata.battery,
            };
            this.TempList.push(payload);
          }
        }
      });
    },
    getChartData() {
      this.chart = false;
      this.sumValHumid = 0;
      this.sumValTemp = 0;
      this.avgValTemp = 0;
      this.avgValHumid = 0;
      this.newArray1 = [];
      this.newArray2 = [];
      this.dateTime = [];
      this.$API.get("indoorsensorlog/all/AC233FA05AE7").then((result) => {
        for (var i = 0; i < result.data.length; i++) {
          let obj = result.data[i];
          this.newArray1.push(obj.sensordata.temperature);
          this.newArray2.push(obj.sensordata.humidity);
          this.dateTime.push(
            this.$moment(obj.timestamp).format("DD/MM/YYYY hh:mm a")
          );
        }
        this.maxValTemp = Math.max.apply(Math, this.newArray1);
        this.minValTemp = Math.min.apply(Math, this.newArray1);
        this.maxValHumid = Math.max.apply(Math, this.newArray2);
        this.minValHumid = Math.min.apply(Math, this.newArray2);
        for (var i = 0; i < this.newArray1.length; i++) {
          this.sumValTemp += this.newArray1[i];
        }
        this.avgValTemp = this.sumValTemp / this.newArray1.length;
        for (var i = 0; i < this.newArray2.length; i++) {
          this.sumValHumid += this.newArray2[i];
        }
        this.avgValHumid = this.sumValHumid / this.newArray2.length;
      });
    },
    defaultChart() {
      this.$API.get("indoorsensorlog/AC233FA05AE7").then((res) => {
        var sum = 0;
        for (var i = 0; i < res.data.length; i++) {
          let obj = res.data[i];
          sum = sum += obj.sensordata.temperature;
          this.datachart1.push(obj.sensordata.temperature);
          this.datachart2.push(obj.sensordata.humidity);
          this.labelInput.push(this.$moment(obj.timestamp).format("LT"));
        }
        this.mintemp = Math.min.apply(Math, this.datachart1);
        this.maxtemp = Math.max.apply(Math, this.datachart1);
        this.avgtemp = sum / this.datachart1.length;
      });
    },
    closeModal() {
      this.$bvModal.hide("modal-1");
    },
    selectTimelengthChart(start, end) {
      let data = {
        mac: "AC233FA05AE7",
        start: start,
        end: end,
      };

        (this.datachart1 = []),
        (this.datachart2 = []),
        (this.labelInput = []),
        this.$API.post("indoorsensorgraph", data).then((res) => {
          if (res.data.length === 0) {
            this.alertselect = true;
          } else {
            this.alertselect = false;
            const data = res.data;
            var sum = 0;
            data.forEach((element) => {
              sum = sum += element.sensordata.temperature;
              this.datachart1.push(element.sensordata.temperature);
              this.datachart2.push(element.sensordata.humidity);
              this.labelInput.push(this.$moment(element.timestamp).format("L"));
            });
            this.mintemp = Math.min.apply(Math, this.datachart1);
            this.maxtemp = Math.max.apply(Math, this.datachart1);
            this.avgtemp = sum / this.datachart1.length;
            this.chartKey += 1;
            this.$bvModal.hide("modal-1");
          }
        });
    },
  },
  components: { Graph, Table },
};
</script>

<style>
@font-face {
  font-family: "7 Segment";
  src: local("7 Segment"),
    url("./../../../../../src/assets/Font/7-Segment-Font/Seven Segment.ttf")
      format("truetype");
}
#HeaderPage {
  font-weight: 400;
  width: 200px;
  border-radius: 20px;
  margin-bottom: 0px;
}
.cardBorder {
  border-radius: 20px;
}
</style>
